import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.wrong.note');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-wrong-note',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.wrong.note/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageWrongNoteComponent implements OnInit {
    public loading: boolean = true;
    public items: any[] = [];
    public subjects: any[] = [];

    public filter: string = 'all';  // all, unmastered, mastered
    public subjectFilter: string = '';
    public page: number = 1;
    public dump: number = 20;
    public total: number = 0;
    public totalAll: number = 0;
    public totalUnmastered: number = 0;
    public totalMastered: number = 0;

    public expandedId: string = '';
    public editingMemoId: string = '';
    public editingMemo: string = '';
    public reviewingId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadSubjects();
        await this.loadList();
        await this.service.render();
    }

    public async loadSubjects() {
        const res = await wiz.call("subjects");
        if (res.code === 200) {
            this.subjects = res.data.rows || [];
        }
    }

    public async loadList() {
        this.loading = true;
        await this.service.render();

        const params: any = { page: this.page, dump: this.dump };
        if (this.filter === 'unmastered') params.mastered = '0';
        else if (this.filter === 'mastered') params.mastered = '1';
        if (this.subjectFilter) params.subject_id = this.subjectFilter;

        const res = await wiz.call("list", params);
        if (res.code === 200) {
            this.items = res.data.rows || [];
            this.total = res.data.total || 0;
            this.totalAll = res.data.total_all || 0;
            this.totalUnmastered = res.data.total_unmastered || 0;
            this.totalMastered = res.data.total_mastered || 0;
        }

        this.loading = false;
        await this.service.render();
    }

    public async setFilter(f: string) {
        this.filter = f;
        this.page = 1;
        await this.loadList();
    }

    public async setSubjectFilter(id: string) {
        this.subjectFilter = id;
        this.page = 1;
        await this.loadList();
    }

    public async goPage(p: number) {
        this.page = p;
        await this.loadList();
    }

    public get totalPages(): number {
        return Math.ceil(this.total / this.dump) || 1;
    }

    public get pages(): number[] {
        const arr: number[] = [];
        const start = Math.max(1, this.page - 2);
        const end = Math.min(this.totalPages, start + 4);
        for (let i = start; i <= end; i++) arr.push(i);
        return arr;
    }

    public toggleExpand(id: string) {
        this.expandedId = this.expandedId === id ? '' : id;
        this.service.render();
    }

    public getTypeLabel(t: string): string {
        const labels: any = {
            'multiple_choice': '5지선다', 'ox': 'OX', 'ordering': '순서배열',
            'matching': '연결하기', 'short_answer': '단답형'
        };
        return labels[t] || t;
    }

    public getDifficultyLabel(d: number): string {
        const labels: any = { 1: '매우 쉬움', 2: '쉬움', 3: '보통', 4: '어려움', 5: '매우 어려움' };
        return labels[d] || `${d}`;
    }

    public getAnswerDisplay(q: any): string {
        if (!q || !q.answer) return '-';
        if (q.question_type === 'multiple_choice') {
            const idx = parseInt(q.answer);
            if (!isNaN(idx) && q.options && q.options[idx]) return q.options[idx];
            return q.answer;
        }
        return q.answer;
    }

    // --- 이미지 문제 헬퍼 ---
    public isImageContent(content: string): boolean {
        return content?.startsWith('[IMG]') || false;
    }

    public getImageUrl(content: string): string {
        if (!this.isImageContent(content)) return '';
        const path = content.substring(5);
        return wiz.app('page.quiz.play').url('question_image') + '?path=' + encodeURIComponent(path);
    }

    // 메모 편집
    public startEditMemo(item: any) {
        this.editingMemoId = item.id;
        this.editingMemo = item.memo || '';
        this.service.render();
    }

    public cancelEditMemo() {
        this.editingMemoId = '';
        this.editingMemo = '';
        this.service.render();
    }

    public async saveMemo() {
        const res = await wiz.call("update_memo", { id: this.editingMemoId, memo: this.editingMemo });
        if (res.code === 200) {
            const item = this.items.find((i: any) => i.id === this.editingMemoId);
            if (item) item.memo = this.editingMemo;
        }
        this.editingMemoId = '';
        this.editingMemo = '';
        await this.service.render();
    }

    // 복습
    public async startReview(item: any) {
        this.reviewingId = item.id;
        await this.service.render();
    }

    public async recordReview(item: any, isCorrect: boolean) {
        const res = await wiz.call("review", { id: item.id, is_correct: isCorrect ? 1 : 0 });
        if (res.code === 200) {
            this.reviewingId = '';
            await this.loadList();
        }
    }

    public cancelReview() {
        this.reviewingId = '';
        this.service.render();
    }

    // 숙달 토글
    public async toggleMastered(item: any) {
        const res = await wiz.call("toggle_mastered", { id: item.id });
        if (res.code === 200) {
            await this.loadList();
        }
    }

    // 삭제
    public async deleteNote(item: any) {
        const res = await wiz.call("delete", { id: item.id });
        if (res.code === 200) {
            await this.loadList();
        }
    }

    public formatDate(d: string): string {
        if (!d) return '-';
        return d.substring(0, 10);
    }
}

export default PageWrongNoteComponent;